import React from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AlertDialog from './AlertDialog';
import Moment from 'react-moment';
import {green400, orange900} from 'material-ui/styles/colors';
import {lfBrown, lfGreen, lfTan} from './lfColors.js';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import '../Add.css';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: lfGreen[300],
    accent1Color: lfGreen[400],
    pickerHeaderColor: green400,
    color:lfTan[100],
  },
  menuItem: {
    selectedTextColor: green400,
  },
});

const styles = {
  customWidth: {
    width: 150,
  },
  
  errorStyle: {
    color: orange900,
  },
  underlineStyle: {
    borderColor: orange900,
  },
};

let dlgActionStyles = {
  backgroundColor: lfBrown[400],
};



let dlgTitleStyles = {
  backgroundColor: lfBrown[400],
  textAlign: 'center',
  fontSize: 32,
  fontWeight:'bold',
  fontFamily: 'Chewy',
  color:lfBrown[800],
};

let datePickerTextStyles = {
  width: 80,
}

let dlgContentStyles = {
  width: 350,
  backgroundColor: lfBrown[400],
};

let dlgBodyStyles = {
  backgroundColor: lfBrown[800],
};



export default class AddLfItemDialog extends React.Component {

  state = {
    error: null, // you could put error messages here if you wanted
    creationTime:new Date(),
    isLost:true,
    useCurrentLocation:true,
    lfType:0,
    name:"",
    extraInformation:"",
    reward:"",
    contactName:"",
    contactEmailAddress:"",
    contactPhoneNumber:"",
    filename:"",
    file:"",

    alertOpen: false,
    alertTitle: "",
    alertMessage: "",

    lastSeenOn: "Last seen on:",
  };


  handleAlertClose = () => {
    this.setState({alertOpen: false});
  };

  handleAdd = () => {
    /* handle validation here */
    let isValid = true;
   
    if( this.state.isLost && this.state.name === "" ){
      this.setState({
        alertOpen: true,
        alertMessage:"Please enter the pet's name."});
      isValid = false;
    }
    else if( this.state.contactName === "" ){
      this.setState({
        alertOpen: true,
        alertMessage:"Please enter a contact name."
      });
      isValid = false;
    }
    else if( this.state.contactEmailAddress === "" ){
      this.setState({
        alertOpen: true,
        alertMessage : "Please enter a contact email address."
      });
      isValid = false;
    }
    else if( this.state.contactPhoneNumber === "" ){
      this.setState({
        alertOpen: true,
        alertMessage : "Please enter a contact phone number."
      });
      isValid = false;
    }

    // this.props.handleAdd({ name: this.state.name })
    if( isValid ){

      let status = 1;
      if( !this.state.isLost ){
        status = 2;
      }

      /* If the user has already clicked on the map and created a marker,
      then the initItem contains the lat, lng from the marker.  Otherwise,
      the user clicked on the Add button, and the lat, lng is not set yet.
      In the second case, the lat, lng will be set by the device's 
      current location, or the user will click on the map after they save the 
      info from the dialog */
      let locationIsSet = false;
      let lat = 0.0;
      let lng = 0.0;
      if( this.props.initItem != null ){
        locationIsSet = true;
        lat = this.props.initItem.lat;
        lng = this.props.initItem.lng;
      }
      this.props.handleAdd(this.state.useCurrentLocation, 
        locationIsSet,
        this.state.file,
        { 
          status:status,          
          name: this.state.name,
          creationTime : this.state.creationTime.getTime(),
          lfType:this.state.lfType,
          extraInformation:this.state.extraInformation,
          reward:this.state.reward,
          contactName:this.state.contactName,
          contactEmailAddress:this.state.contactEmailAddress,
          contactPhoneNumber:this.state.contactPhoneNumber,
          filename:this.state.filename,
          lat:lat,
          lng:lng
        })
    }
  };
    
  handleCancel = () => {
    this.props.handleCancel()
  };

  
  handleDateChange = (event, dateValue) => {
     this.setState({
      creationTime: dateValue
    });
  }

  handleImageChange(event) {
    event.preventDefault();

    let reader = new FileReader();
    let file = event.target.files[0];
    // let tmpPath = URL.createObjectURL(event.target.files[0]);
    reader.onloadend = () => {
      this.setState({
        file:file,
        filename: file.name,
        imagePreviewUrl: reader.result
      });
    }

    reader.readAsDataURL(file)
  }


  handleRadioButtonClick = (event ) => {
    if (event.target.id === 'rbIsLost') {
      this.setState({
        isLost: true,
        lastSeenOn: "Last seen on:"
      });
    } 
    else if (event.target.id === 'rbIsFound') {
      this.setState({
        isLost: false,
        lastSeenOn: "Found on:"
      });
    } 
    else if (event.target.id === 'rbUseCurrentLocation') {
      this.setState({
        useCurrentLocation:true,
      });
    } 
    else if (event.target.id === 'rbWillClickOnMap') {
      this.setState({
        useCurrentLocation:false,
      });
    } 
  }

  /* 
      Key is the index of the array, and 
      value is value of the array item at the index.
      In this case, the values are integers that are the same as the key.
  
      Currently the id field is not working.
      */
  handleMenuChange = (event, key, value) => {
   
    this.setState({
      lfType: value,
    });
      
  }

  handleTextFieldChange = (event, newValue ) => {
    // event.target.value is the same as newValue
     if (event.target.id === 'name') {
      this.setState({
        name: newValue,
      });
    } 
  else if (event.target.id === 'extraInformation') {
      this.setState({
        extraInformation: newValue,
      });
    } 
    else if (event.target.id === 'reward') {
      this.setState({
        reward: newValue,
      });
    } 
    else if (event.target.id === 'contactName') {
      this.setState({
        contactName: newValue,
      });
    } 
    else if (event.target.id === 'contactEmailAddress') {
      this.setState({
        contactEmailAddress: newValue,
      });
    } 
    else if (event.target.id === 'contactPhoneNumber') {
      this.setState({
        contactPhoneNumber: newValue,
      });
    }

  };



  render() {

    const actions = [
      
      <RaisedButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCancel}
        className="dlgCancelAddButton"
      />,
      <RaisedButton
        label="Save"
        primary={true}

        onClick={this.handleAdd}
        className="dlgAddButton"
      />,
    ];

    /* Check to see if this dialog was opened because a user clicked on
      a marker that was in the 'init' state.  In that use case, the location is
      already set */
    let $locationRadioButtonsLabelDiv = null;
    let $locationRadioButtonsDiv = null;
    if( this.props.initItem != null ){
      $locationRadioButtonsLabelDiv = (<div style={{display: 'none'}}></div>);
      $locationRadioButtonsDiv = (<div style={{display: 'none'}}></div>);
    }
    else{

      /* Location selection radio buttons */
      const locationRadioButtons = [];
      locationRadioButtons.push( <RadioButton 
        id="rbUseCurrentLocation" key={0} value={0} 
        onClick={this.handleRadioButtonClick}
        label={`I want to use my device's current location`}
        
        className="locationRadioButton"/>      
      );
      locationRadioButtons.push( <RadioButton 
        id="rbWillClickOnMap" key={1} value={1}
        onClick={this.handleRadioButtonClick}
        label={`I will click on the map`}
        className="locationRadioButton"
        />      
      );
      $locationRadioButtonsLabelDiv = (
        <div className="lastKnownLocationLabel">Set last known location</div> );
      $locationRadioButtonsDiv = (
        <RadioButtonGroup name="locationRadioButtonGroup" defaultSelected={0} >
        {locationRadioButtons}
      </RadioButtonGroup> );
    }


    /* Lost or Found selection radio buttons. */
    const statusRadioButtons = [];
    statusRadioButtons.push( <RadioButton  
      id="rbIsLost" key={1} value={1}
      onClick={this.handleRadioButtonClick}
      label={`This pet is lost`}
      className="statusRadioButton"
      />      
    );
    statusRadioButtons.push( <RadioButton 
        id="rbIsFound" key={2} value={2}
        onClick={this.handleRadioButtonClick}
        label={`This pet is found`}
        className="statusRadioButton"
        />      
    );
    
    const typeMenuItems = [];
    typeMenuItems.push( <MenuItem value={0} key={0} primaryText={`Dog`} />);
    typeMenuItems.push( <MenuItem value={1} key={1} primaryText={`Cat`} />);
    typeMenuItems.push( <MenuItem value={2} key={2} primaryText={`Bird`} />);
    typeMenuItems.push( <MenuItem value={3} key={3} primaryText={`Reptile`} />);
    typeMenuItems.push( <MenuItem value={4} key={4} primaryText={`Other`} />);
    
    let nameHint = "Pet's name";
    if( this.state.isLost === false )
      nameHint = "Photo caption ( optional )";


    const extraInfoHint = "Any extra information that might help.  For example, the breed."
    const rewardHint = "Reward (optional)"
    const contactNameHint = "Name"
    const contactEmailAddressHint = "Email address"
    const contactPhoneNumberHint = "Phone number"



    let {imagePreviewUrl} = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (<img  className="previewImage" width="200" height="200" alt="Pet" src={imagePreviewUrl} />);
    } else {
      $imagePreview = (<div className="previewText">Please select a photo</div>);
    }

    let $addWrapperClassName = 'addWrapper';
    let $statusRadioGroupClassName = 'statusRadioButtonGroup';
    if( this.props.initItem != null ){
      $addWrapperClassName = 'addWrapperSmall';
      $statusRadioGroupClassName = 'statusRadioButtonGroupSmall';
    }

    return (
      <div className="addDialogMainDiv">
      
      {/* Note if modal is set to true, then onRequestClose does not fire */}
      
      <MuiThemeProvider muiTheme={muiTheme}>
      <Dialog

          title="Add a lost or found pet"
          actions={actions}
          modal={false}          
          open={this.props.open}
          onRequestClose={this.handleCancel}
          autoScrollBodyContent={true}
          actionsContainerStyle={dlgActionStyles}
          contentStyle={dlgContentStyles}
          titleStyle={dlgTitleStyles}
          bodyStyle={dlgBodyStyles}
      >
    
        <div className={$addWrapperClassName}>

          <div className="imageContainer">
            {/* Image preview */}
            {$imagePreview}

            <input className="browseFile" 
              type="file" 
              onChange={(e)=>this.handleImageChange(e)} />
          </div>

          <div className="locationAndStatusContainer">

              {/* Location radio buttons.  Allows the user to set the location from
              their device's current location, or click on the map. */}
              {$locationRadioButtonsLabelDiv}
              <MuiThemeProvider muiTheme={muiTheme} >
                {$locationRadioButtonsDiv}
              </MuiThemeProvider>
    
              {/* Status radio buttons.  Note that default is 0, which means it's status
              is init, not lost or found.  This happens when a user clicks on the map to 
              add a new item.  The marker is grey. */}
              <MuiThemeProvider muiTheme={muiTheme} >
                <RadioButtonGroup className={$statusRadioGroupClassName} name="status" defaultSelected={1}>
                  {statusRadioButtons}
                </RadioButtonGroup>
              </MuiThemeProvider>
        
          </div>

          <div className="nameContainer">
            {/* Type menu */}
            <div className="typeLabel">This pet is a: </div>

            <MuiThemeProvider muiTheme={muiTheme}>
              <DropDownMenu 
                
                className="typeDropdown"
                maxHeight={100} 
                autoWidth={false} 
                value={this.state.lfType}
                onChange={this.handleMenuChange}>
                {typeMenuItems}
              </DropDownMenu>
            </MuiThemeProvider>

              {/* Name or caption */}
              <TextField
                id="name"
                hintText={nameHint}
                fullWidth={true}
                value={this.state.name}
                onChange={this.handleTextFieldChange}
                className="tfName"
              />

              {/*Extra information */}
              <TextField
                id="extraInformation"
                hintText={extraInfoHint}
                multiLine={true}
                rows={3}
                fullWidth={true}
                value={this.state.extraInformation}
                onChange={this.handleTextFieldChange}
                className="tfExtraInformation"
              />

              {/* Reward */}
              <TextField
                id="reward"
                hintText={rewardHint}
                fullWidth={true}
                value={this.state.reward}
                onChange={this.handleTextFieldChange}
                className="tfReward"
              />

              <div className="datePickerLabel">{this.state.lastSeenOn}</div>
              <MuiThemeProvider muiTheme={muiTheme}>
                <DatePicker 
                  className="datePicker"
                  textFieldStyle={datePickerTextStyles}
                  hintText={ <Moment format="MMM. DD, YYYY">{this.state.creationTime}</Moment>} 
                  value={this.state.creationTime}  
                  onChange={this.handleDateChange}  />
              </MuiThemeProvider>

            </div>
           

            {/* Contact info */}
            <div className="contactInfoContainer">
              <div className="contactInfoLabel">Contact information</div>
              <TextField 
                id="contactName"
                fullWidth={true}
                errorText="*Required"
                errorStyle={styles.errorStyle}
                underlineStyle={styles.underlineStyle}
                hintText={contactNameHint}
                value={this.state.contactName}
                onChange={this.handleTextFieldChange}
                className="tfContactName"
              />

              <TextField
                id="contactEmailAddress"
                fullWidth={true}
                errorText="*Required"
                errorStyle={styles.errorStyle}
                underlineStyle={styles.underlineStyle}
                hintText={contactEmailAddressHint}
                value={this.state.contactEmailAddress}
                onChange={this.handleTextFieldChange}
                className="tfContactEmail"
              />

              <TextField
                id="contactPhoneNumber"
                fullWidth={true}
                errorText="*Required"
                errorStyle={styles.errorStyle}
                underlineStyle={styles.underlineStyle}
                hintText={contactPhoneNumberHint}
                value={this.state.contactPhoneNumber}
                onChange={this.handleTextFieldChange}
                className="tfContacPhoneNumber"
              />
            </div> {/* contactInfoDiv */}
 
          </div>
        
      </Dialog> 
      </MuiThemeProvider>
             
        <MuiThemeProvider>
          <AlertDialog 
          message={this.state.alertMessage} 
          open={this.state.alertOpen}
          handleAlertClose={this.handleAlertClose}
          />
        </MuiThemeProvider>

      </div>
    
    );
  
  }
}


// WEBPACK FOOTER //
// ./src/Components/AddLfItemDialog.js